import React from 'react';
import laModernaDiscoverSphere from '../assets/images/descubre.png';
import laModernaHaappyParty from '../assets/images/felicesFiestas.png';
import laModernaLogo from'../assets/images/logoLm.png';
import laModernaPinata from'../assets/images/pinata.png';
import laModernaGift from '../assets/images/regalo.png';
import laModernaKit from '../assets/images/kit.png';
import laModernaTikets from '../assets/images/tickets.png';
import laModernaTrivia1 from '../assets/images/trivia_pregunta-1.png';
import laModernaTrivia2 from '../assets/images/trivia_pregunta-2.png';
import laModernaTrivia3 from '../assets/images/trivia_pregunta-3.png';
import laModernaTrivia4 from '../assets/images/trivia_pregunta-4.png';
import laModernaTrivia5 from '../assets/images/trivia_pregunta-5.png';
import laModernaTrivia6 from '../assets/images/trivia_pregunta-6.png';
import laModernaTrivia7 from '../assets/images/trivia_pregunta-7.png';
import laModernaTrivia8 from '../assets/images/trivia_pregunta-8.png';
import laModernaEnvelop from '../assets/images/envelope.png';
import laModernaBookWined from '../assets/images/libro-ganado.png';
import laModernaKitWined from '../assets/images/kit-ganado.png';
import laModernaCineWined from '../assets/images/tickets-ganado.png';
import laModernaPostal1 from '../assets/images/Postales-01.png';
import laModernaPostal2 from '../assets/images/Postales-02.png';
import laModernaPostal3 from '../assets/images/Postales-03.png';
import laModernaPostal4 from '../assets/images/Postales-04.png';
import laModernaPostal5 from '../assets/images/Postales-05.png';
import laModernaPostal6 from '../assets/images/Postales-06.png';
import laModernaPostal7 from '../assets/images/Postales-07.png';
import laModernaPostal8 from '../assets/images/Postales-08.png';
import laModernaPostal9 from '../assets/images/Postales-09.png';
import laModernaPostal10 from '../assets/images/Postales-10.png';
import laModernaPostal11 from '../assets/images/Postales-11.png';
import laModernaRecipe1 from '../assets/images/receta-01.png';
import laModernaRecipe2 from '../assets/images/receta-02.png';
import laModernaRecipe3 from '../assets/images/receta-03.png';
import laModernaRecipe4 from '../assets/images/receta-04.png';
import laModernaRecipe5 from '../assets/images/receta-05.png';
import laModernaRecipe6 from '../assets/images/receta-06.png';
import laModernaRecipe7 from '../assets/images/receta-07.png';
import laModernaRecipe8 from '../assets/images/receta-08.png';
import laModernaRecipe9 from '../assets/images/receta-09.png';
import laModernaRecipe10 from '../assets/images/receta-10.png';
import laModernaRecipe11 from '../assets/images/receta-11.png';
import laModernaRecipe12 from '../assets/images/receta-12.png';
import laModernaRecipe13 from '../assets/images/receta-13.png';
import laModernaRecipe14 from '../assets/images/receta-14.png';
import laModernaRecipe15 from '../assets/images/receta-15.png';
import laModernaRecipe16 from '../assets/images/receta-16.png';
import laModernaRecipe17 from '../assets/images/receta-17.png';
import laModernaRecipe18 from '../assets/images/receta-18.png';
import laModernaRecipe19 from '../assets/images/receta-19.png';
import laModernaRecipe20 from '../assets/images/receta-20.png';
import laModernaRecipe21 from '../assets/images/receta-21.png';
import laModernaRecipe22 from '../assets/images/receta-22.png';
import laModernaRecipe23 from '../assets/images/receta-23.png';
import laModernaRecipe24 from '../assets/images/receta-24.png';
import laModernaXplosion from '../assets/images/confeti.png';
import laModernaPz1 from '../assets/images/pz1.png';
import laModernaPz2 from '../assets/images/pz2.png';
import laModernaPz3 from '../assets/images/pz3.png';
import laModernaPz4 from '../assets/images/pz4.png';

const separeProps = (props) => {
    const { customClass, customStyle, customID } = props;
    return {
        customClass: customClass || '',
        customStyle: customStyle || {},
        customID: customID || ''
    };
};

export const MainLogo = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaLogo} className={customClass} style={customStyle} alt="La Moderna, logo" />
    );
};

export const MainPinata = (props) => {
    const { customClass, customStyle, customID } = separeProps(props);
    return (
        <img src={laModernaPinata} id={customID} className={`main-pinata ${customClass}`} style={customStyle} alt="La Moderna, piñata" />
    );
};

export const DiscoverSphere = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaDiscoverSphere} className={`discover-sphere ${customClass}`} style={customStyle} alt="La Moderna, descubre" />
    );
};

export const DiscoverGift = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaGift} className={`discover-gift ${customClass}`} style={customStyle} alt="La Moderna, regalo" />
    );
};

export const DiscoverHappyParty = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaHaappyParty} className={`discover-happy-party ${customClass}`} style={customStyle} alt="La Moderna, felices fiestas" />
    );
};

export const TiketsPrizeKitCinema = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaTikets} className={`tikets-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, boletos de cine" />
    );
};

export const KitPrizeKitCinema = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaKit} className={`kit-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, Kit de regalo" />
    );
};

export const BigEnvelope = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaEnvelop} className={`envelop-big-cinema ${customClass}`} style={customStyle} alt="La Moderna, Sobre" />
    );
};

export const PrizeBookWined = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaBookWined} className={`kit-prizekit-wined-cinema ${customClass}`} style={customStyle} alt="La Moderna, Libro de regalo" />
    );
};

export const PrizeCinemaWined = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaCineWined} className={`cine-prizekit-wined-cinema ${customClass}`} style={customStyle} alt="La Moderna, Boletos de regalo" />
    );
};

export const PrizeKitWined = (props) => {
    const { customClass, customStyle } = separeProps(props);
    return (
        <img src={laModernaKitWined} className={`kit-prizekit-wined-cinema ${customClass}`} style={customStyle} alt="La Moderna, Kit de regalo" />
    );
};

export const TriviaQuestion = (props) => {
    const { number } = props;
    const { customClass, customStyle } = separeProps(props);
    let content = null;
    switch (number) {
        case 1:
            content = (<img src={laModernaTrivia1} className={`triviaimage-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, Trivia" />);
            break;
        case 2:
            content = (<img src={laModernaTrivia2} className={`triviaimage-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, Trivia" />);
            break;
        case 3:
            content = (<img src={laModernaTrivia3} className={`triviaimage-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, Trivia" />);
            break;
        case 4:
            content = (<img src={laModernaTrivia4} className={`triviaimage-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, Trivia" />);
            break;
        case 5:
            content = (<img src={laModernaTrivia5} className={`triviaimage-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, Trivia" />);
            break;
        case 6:
            content = (<img src={laModernaTrivia6} className={`triviaimage-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, Trivia" />);
            break;
        case 7:
            content = (<img src={laModernaTrivia7} className={`triviaimage-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, Trivia" />);
            break;
        case 8:
            content = (<img src={laModernaTrivia8} className={`triviaimage-prizekit-cinema ${customClass}`} style={customStyle} alt="La Moderna, Trivia" />);
            break;
        default:
            break;
    }
    return content;
};

export const GetPostal = (props) => {
    const { number } = props;
    const { customClass, customStyle } = separeProps(props);
    let content = null;

    switch (number) {
        case 1:
            content = (<img src={laModernaPostal1} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 2:
            content = (<img src={laModernaPostal2} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 3:
            content = (<img src={laModernaPostal3} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 4:
            content = (<img src={laModernaPostal4} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 5:
            content = (<img src={laModernaPostal5} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 6:
            content = (<img src={laModernaPostal6} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 7:
            content = (<img src={laModernaPostal7} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 8:
            content = (<img src={laModernaPostal8} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 9:
            content = (<img src={laModernaPostal9} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 10:
            content = (<img src={laModernaPostal10} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        case 11:
            content = (<img src={laModernaPostal11} className={`postal-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, Postal" />);
            break;
        default:
            break;
    }
    return content;
};

export const getPostalURL = (number) => {
    let url = '';

    switch (number) {
        case 1:
            url = laModernaPostal1;
            break;
        case 2:
            url = laModernaPostal2;
            break;
        case 3:
            url = laModernaPostal3;
            break;
        case 4:
            url = laModernaPostal4;
            break;
        case 5:
            url = laModernaPostal5;
            break;
        case 6:
            url = laModernaPostal6;
            break;
        case 7:
            url = laModernaPostal7;
            break;
        case 8:
            url = laModernaPostal8;
            break;
        case 9:
            url = laModernaPostal9;
            break;
        case 10:
            url = laModernaPostal10;
            break;
        case 11:
            url = laModernaPostal11;
            break;
        default:
            break;
    }
    return url;
};

export const GetRecipe = (props) => {
    const { number } = props;
    const { customClass, customStyle } = separeProps(props);
    let content = null;
    switch (number) {
        case 1:
            content = (<img src={laModernaRecipe1} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 2:
            content = (<img src={laModernaRecipe2} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 3:
            content = (<img src={laModernaRecipe3} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 4:
            content = (<img src={laModernaRecipe4} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 5:
            content = (<img src={laModernaRecipe5} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 6:
            content = (<img src={laModernaRecipe6} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 7:
            content = (<img src={laModernaRecipe7} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 8:
            content = (<img src={laModernaRecipe8} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 9:
            content = (<img src={laModernaRecipe9} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 10:
            content = (<img src={laModernaRecipe10} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 11:
            content = (<img src={laModernaRecipe11} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 12:
            content = (<img src={laModernaRecipe12} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 13:
            content = (<img src={laModernaRecipe13} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 14:
            content = (<img src={laModernaRecipe14} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 15:
            content = (<img src={laModernaRecipe15} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 16:
            content = (<img src={laModernaRecipe16} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 17:
            content = (<img src={laModernaRecipe17} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 18:
            content = (<img src={laModernaRecipe18} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 19:
            content = (<img src={laModernaRecipe19} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 20:
            content = (<img src={laModernaRecipe20} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 21:
            content = (<img src={laModernaRecipe21} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 22:
            content = (<img src={laModernaRecipe22} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 23:
            content = (<img src={laModernaRecipe23} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        case 24:
            content = (<img src={laModernaRecipe24} className={`receta-imagecard-cinema ${customClass}`} style={customStyle} alt="La Moderna, receta" />);
            break;
        default:
            break;
    }
    return content;
};

export const Xplosion = () => {
    return (
        <div className="pinata-xplosion">
            <img src={laModernaXplosion} className={`confeti`} alt="La Moderna, confeti" />
            <img src={laModernaPz1} className={`pz1`} alt="La Moderna, piñata pieza 1" />
            <img src={laModernaPz2} className={`pz2`} alt="La Moderna, piñata pieza 2" />
            <img src={laModernaPz3} className={`pz3`} alt="La Moderna, piñata pieza 3" />
            <img src={laModernaPz4} className={`pz4`} alt="La Moderna, piñata pieza 4" />
        </div>
    );
}
